import { connect } from 'react-redux';
import { onClick } from './events/onClick';
import {
    IAsidePanelCommentsColumnViewButtonEvents,
    IAsidePanelCommentsColumnViewButtonFields
} from '../../components/AsidePanelCommentsColumnViewButton/types';
import {
    AsidePanelCommentsColumnViewButton
} from '../../components/AsidePanelCommentsColumnViewButton/AsidePanelCommentsColumnViewButton';
import { IApplicationState } from '../../../../../../types/types';
import { getBoardPermissions } from '../../../../../../store/model/selectors/getBoardPermissions';
import { IAsidePanelCommentsColumnViewHOCProps } from './types';
import { getBoard } from '../../../../../../store/model/selectors/getBoardById';
import { isBoardCardsLimitReached } from '../../../../../../store/model/selectors/isBoardCardsLimitReached';
import { getBoardIsOnSharedDrive } from '../../../../../../store/model/selectors/getBoardIsOnSharedDrive';
import { getAuthUser } from '../../../../../../store/model/authUser/selectors/getAuthUser';
import { getIsChatViewActive } from '../../../../../../store/router/selectors/getIsChatViewActive';
import { getHintCanShow } from '../../../../hints/store/hint/selectors/getHintCanShow';
import { EHintKey, EHintStatus } from '../../../../hints';
import { getHint } from '../../../../hints/store/hints/selectors/getHint';
import { onHintHide } from './events/onHintHide';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IAsidePanelCommentsColumnViewHOCProps,
): IAsidePanelCommentsColumnViewButtonFields => {
    const boardPermissions = getBoardPermissions(state, boardId);
    const authPermissions = boardPermissions && boardPermissions.authPermissions;
    const allowEdit = authPermissions && authPermissions.allowEdit;
    const isShow = allowEdit &&
        !getBoard(state, boardId).lockDate &&
        !getIsChatViewActive(state) &&
        !isBoardCardsLimitReached(state, boardId, 0) &&
        (
            !getBoardIsOnSharedDrive(state, boardId) ||
            getBoardIsOnSharedDrive(state, boardId) &&
            getAuthUser(state).allowSharedDrive
        );
    return {
        isShow,
        isNew: getHint(state, EHintKey.ASIDE_COLUMN_TOGGLE).status !== EHintStatus.SHOWN && !!getHintCanShow(state, EHintKey.ASIDE_COLUMN_TOGGLE),
    }
};

const mapDispatchToProps = (
    dispatch: any,
): IAsidePanelCommentsColumnViewButtonEvents => {
    return {
        onClick: () => dispatch(onClick()),
        onHintHide: () => dispatch(onHintHide()),
    }
};

export const AsidePanelCommentsColumnViewButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(AsidePanelCommentsColumnViewButton);

AsidePanelCommentsColumnViewButtonHOC.displayName = 'AsidePanelCommentsColumnViewButtonHOC';
